/* eslint-disable @typescript-eslint/no-explicit-any */
import { AxiosInstance, AxiosResponse } from "axios";

export type ServiceKind = "internet" | "cloud" | "datacenter" | "port";

// type CommonData = { name?: string; tag?: string };
type CommonData = { name?: string; tag?: string | string[] };

// Discriminated union enforces tenantId where needed
export type UpdateMetaParams =
  | {
      kind: "internet" | "cloud" | "datacenter";
      resourceId: string;        // connectionId or datacenterId
      tenantId: number;
      data: CommonData;
    }
  | {
      kind: "port";
      resourceId: string;  
      tenantId: number;      // portId
      data: CommonData;          // no tenantId for port
    };

export function updateConnectionMeta(
  api: AxiosInstance,
  params: UpdateMetaParams
): Promise<AxiosResponse> {
  const { kind, resourceId, data } = params;

  switch (kind) {
    case "internet": {
      // PATCH /kontroledge/internet/:id?tenantId=...
      return api.patch(
        `/kontroledge/internet/${resourceId}?tenantId=${params.tenantId}`,
        data
      );
    }
    case "cloud": {
      // PATCH /kontroledge/cloud-connectivity/:id?tenantId=...
      return api.patch(
        `/kontroledge/cloud-connectivity/${resourceId}?tenantId=${params.tenantId}`,
        data
      );
    }
    case "datacenter": {
      // PUT /kontroledge/datacenter-interconnect/:id?tenantId=...
      return api.put(
        `/kontroledge/datacenter-interconnect/${resourceId}?tenantId=${params.tenantId}`,
        data
      );
    }
    case "port": {
      // PATCH /kontroledge/ports/:id   (no tenantId)
      return api.patch(`/kontroledge/ports/${resourceId}?tenantId=${params.tenantId}`, data);
    }
    default: {
      // Exhaustive check
      const _never: never = kind;
      return Promise.reject(new Error(`Unsupported kind: ${_never as any}`));
    }
  }
}

